import { BalanceContext } from '@app/collections/fortress/BalanceContext'
import { Col, Divider, Row, Spacer, Text } from '@app/components'
import { IStore } from '@app/redux'
import { auth, Axios } from '@app/services'
import { toCurrency } from '@app/utils'
import { ETHEREUM_MAINNET_ID, useWalletChainId } from 'libs/ethereum/useWalletChainId'
import useCSTBalance, {
  useEhexBalance,
  useGloryBalance,
  useHexBalance,
  useIncBalance,
  usePhlpBalance,
  usePlsxBalance,
  usePrvxBalance,
  useTideBalance,
  useWaitBalance,
  useWPlsBalance,
} from 'libs/services/hooks/useCSTBalance'
import React, { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useAccount } from 'wagmi'

import { CoastIcon, HexIcon, PulseChainIcon, PulseXIcon } from '~public'
//import { useMintFee } from 'libs/services/hooks/useFee'
import { GloryIcon } from '~public/icons/GloryIcon'
import { IncIcon } from '~public/icons/IncIcon'
import { PHLPv2Icon } from '~public/icons/PHLPv2Icon'
import { ProveXIcon } from '~public/icons/ProveXIcon'
import { TideIcon } from '~public/icons/TideIcon'

import { UserInfoContext } from '../fortress/UserInfoContext'
import { CurrencyInput } from './currency-input'
import { Summary } from './summary'
import { Transaction } from './transactions/Transactions'

// PiteasSell component

export const PiteasSell: React.FC = () => {
  const { user } = useSelector((state: IStore) => state)

  const { fetchAccounts } = useContext(BalanceContext)
  const { fetchUserInfo } = useContext(UserInfoContext)
  const [selectedWallet] = useState<any>({ name: '', val: '' })
  const [selectedMethod] = useState<any>({ name: '', val: '' })
  const [cst, setCst] = useState(0)
  //const [coastBalance, setCoastBalance] = useState(0)
  const fee = 2 //useMintFee()

  // Input states (Pay and Receive)
  const { address } = useAccount()
  const chainId = useWalletChainId()
  const onEthereum = chainId === ETHEREUM_MAINNET_ID
  const [payAmount, setPayAmount] = useState(0)
  const [payType, setPayType] = useState(onEthereum ? 'eHEX' : 'wPLS')

  const [receiveAmount, setReceiveAmount] = useState(0)
  const [receiveType, setReceiveType] = useState('USD')
  const [transactionRefresh, setTransactionRefresh] = useState(0)

  const PlsBalance = useWPlsBalance(transactionRefresh)
  const PlsxBalance = usePlsxBalance(transactionRefresh)
  const HexBalance = useHexBalance(transactionRefresh)
  const WaitBalance = useWaitBalance(transactionRefresh)
  const IncBalance = useIncBalance(transactionRefresh)
  const PhlpBalance = usePhlpBalance(transactionRefresh)
  const TideBalance = useTideBalance(transactionRefresh)
  const GloryBalance = useGloryBalance(transactionRefresh)
  const PrvxBalance = usePrvxBalance(transactionRefresh)
  const CSTBalance = useCSTBalance(transactionRefresh)
  const EhexBalance = useEhexBalance(transactionRefresh)

  const [queueLength, setQueueLength] = useState(0)

  useEffect(() => {
    if (onEthereum) {
      setPayType('eHEX')
      setPayAmount(0)
      setReceiveAmount(0)
    } else if (payType === 'eHEX') {
      setPayType('wPLS')
      setPayAmount(0)
      setReceiveAmount(0)
    }
  }, [onEthereum])

  useEffect(() => {
    fetchAccounts()
    fetchUserInfo()
  }, [transactionRefresh])

  async function fetchQueueLength() {
    const authorization = await auth.currentUser.getIdToken()
    const params = { identityId: user.fortressIdentityId }
    const headers = {
      Authorization: authorization,
    }

    const res = await Axios.get('api/gcloud/queues', { params, headers })

    // eslint-disable-next-line no-console
    console.log('Number of tasks in the queue:', res.data.length)
    setQueueLength(res.data.length)
  }

  useEffect(() => {
    if (onEthereum) return
    fetchQueueLength()
  }, [transactionRefresh, receiveAmount, onEthereum])

  const setAmount = (value: number, title: string) => {
    //setType(title)
    if (selectedMethod.name == 'Connected Wallet') {
      setPayAmount(value ? value : 0)
      setReceiveAmount(value ? value : 0)
    } else if (title == 'You Sell') {
      if (value == 0 || !value) {
        setPayAmount(0)
        setReceiveAmount(0)
      } else {
        setPayAmount(value)
      }
      //Do not change this line of code
      //setReceiveAmount(value ? round(value * (1 - fee / 100), 2) : 0)
    }
  }

  return (
    <>
      <Row justify="space-between">
        <Col span={24} lg={12} sm={24}>
          <CurrencyInput
            pay={{ amount: payAmount, setAmount: setPayAmount, type: payType, setType: setPayType }}
            receive={{
              amount: receiveAmount,
              setAmount: setReceiveAmount,
              type: receiveType,
              setType: setReceiveType,
            }}
            setAmount={setAmount}
            balance={
              payType == 'eHEX'
                ? Number(EhexBalance.value || 0) / 10 ** 8
                : payType == 'wPLS'
                  ? Number(PlsBalance.value) / 10 ** 18
                  : payType == 'PLSX'
                    ? Number(PlsxBalance.value) / 10 ** 18
                    : payType == 'HEX'
                      ? Number(HexBalance.value) / 10 ** 8
                      : payType == 'WAIT'
                        ? Number(WaitBalance.value) / 10 ** 8
                        : payType == 'INC'
                          ? Number(IncBalance.value) / 10 ** 18
                          : payType == 'PHLPv2'
                            ? Number(PhlpBalance.value) / 10 ** 18
                            : payType == 'TIDE'
                              ? Number(TideBalance.value) / 10 ** 18
                              : payType == 'CST'
                                ? Number(CSTBalance.value) / 10 ** 6
                                : payType == 'GLORY'
                                  ? Number(GloryBalance.value) / 10 ** 6
                                  : 0
            }
          />
          <Spacer value={40} />

          <Row style={{ rowGap: '45px', columnGap: '45px' }}>
            <Col span={24}>
              <Row justify={'space-between'}>
                <Col style={{ marginBottom: 10 }}>
                  <Text>Connected Wallet</Text>
                </Col>
              </Row>
              <Divider style={{ marginTop: 0 }} />
              {address != undefined && onEthereum ? (
                <Row gutter={[10, 10]}>
                  <Col>
                    <HexIcon style={{ height: 55, width: 55 }} />
                  </Col>
                  <Col>
                    <Text>Ethereum HEX</Text>
                    <Spacer value={1} />
                    <Text type="secondary">{toCurrency(Number(EhexBalance.value || 0) / 10 ** 8, false)} eHEX</Text>
                  </Col>
                </Row>
              ) : address != undefined && chainId == parseInt(process.env.NEXT_PUBLIC_PULSECHAIN) ? (
                <>
                  <Row gutter={[10, 10]}>
                    <Col span={8} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      {/* Pulse */}
                      <Col style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <PulseChainIcon style={{ height: 70, width: 70, marginBottom: '0px' }} />
                        <Text type="secondary">
                          <>
                            {address != undefined ? <>{toCurrency(Number(PlsBalance.value) / 10 ** 18, false)}</> : '0'}
                          </>
                        </Text>
                      </Col>
                    </Col>
                    <Col span={8} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      {/* PulseX */}
                      <Col style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <PulseXIcon style={{ height: 50, width: 50, marginBottom: '5px' }} />
                        <Text type="secondary">
                          <>
                            {address != undefined ? (
                              <>{toCurrency(Number(PlsxBalance.value) / 10 ** 18, false)}</>
                            ) : (
                              '0'
                            )}
                          </>
                        </Text>
                      </Col>
                    </Col>
                    <Col span={8} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      {/* HEX */}
                      <Col style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <HexIcon style={{ height: 50, width: 50, marginLeft: '5px', marginBottom: '5px' }} />
                        <Text type="secondary" style={{ marginLeft: '5px' }}>
                          <>
                            {address != undefined ? <>{toCurrency(Number(HexBalance.value) / 10 ** 8, false)}</> : '0'}
                          </>
                        </Text>
                      </Col>
                    </Col>
                  </Row>
                  <Spacer value={30} />
                  <Row gutter={[10, 10]}>
                    <Col span={8} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      {/* INC */}
                      <Col style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IncIcon style={{ height: 50, width: 50, marginLeft: '5px', marginBottom: '5px' }} />
                        <Text type="secondary" style={{ marginLeft: '5px' }}>
                          <>
                            {address != undefined ? <>{toCurrency(Number(IncBalance.value) / 10 ** 18, false)}</> : '0'}
                          </>
                        </Text>
                      </Col>
                    </Col>
                    <Col span={8} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      {/* PHLPv2 */}
                      <Col style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <PHLPv2Icon style={{ height: 50, width: 50, marginLeft: '5px', marginBottom: '5px' }} />
                        <Text type="secondary" style={{ marginLeft: '5px' }}>
                          <>
                            {address != undefined ? (
                              <>{toCurrency(Number(PhlpBalance.value) / 10 ** 18, false)}</>
                            ) : (
                              '0'
                            )}
                          </>
                        </Text>
                      </Col>
                    </Col>
                    <Col span={8} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      {/* CST */}
                      <Col style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <CoastIcon style={{ height: 50, width: 50, marginBottom: '5px' }} />
                        <Text type="secondary">
                          <>
                            {address != undefined ? <>{toCurrency(Number(CSTBalance.value) / 10 ** 6, false)}</> : '0'}
                          </>
                        </Text>
                      </Col>
                    </Col>
                  </Row>
                  <Spacer value={30} />
                  <Row gutter={[10, 10]}>
                    <Col span={8} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      {/* PRVX */}
                      <Col style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <ProveXIcon style={{ height: 50, width: 50, marginLeft: '5px', marginBottom: '5px' }} />
                        <Text type="secondary" style={{ marginLeft: '5px' }}>
                          <>
                            {address != undefined ? (
                              <>{toCurrency(Number(PrvxBalance.value) / 10 ** 18, false)}</>
                            ) : (
                              '0'
                            )}
                          </>
                        </Text>
                      </Col>
                    </Col>
                    <Col span={8} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      {/* GLORY */}
                      <Col style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <GloryIcon style={{ height: 50, width: 50, marginLeft: '5px', marginBottom: '5px' }} />
                        <Text type="secondary" style={{ marginLeft: '5px' }}>
                          <>
                            {address != undefined ? (
                              <>{toCurrency(Number(GloryBalance.value) / 10 ** 6, false)}</>
                            ) : (
                              '0'
                            )}
                          </>
                        </Text>
                      </Col>
                    </Col>
                    <Col span={8} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      {/* TIDE */}
                      <Col style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <TideIcon style={{ height: 50, width: 50, marginLeft: '5px', marginBottom: '5px' }} />
                        <Text type="secondary" style={{ marginLeft: '5px' }}>
                          <>
                            {address != undefined ? (
                              <>{toCurrency(Number(TideBalance.value) / 10 ** 18, false)}</>
                            ) : (
                              '0'
                            )}
                          </>
                        </Text>
                      </Col>
                    </Col>
                  </Row>
                </>
              ) : (
                <Row gutter={[10, 10]}>
                  <Col>
                    <CoastIcon style={{ height: 55, width: 55 }} />
                  </Col>
                  <Col>
                    <Text>Current Balance</Text>
                    <Spacer value={1} />
                    <Text type="secondary">Connect wallet</Text>
                  </Col>
                </Row>
              )}
            </Col>

            <Spacer />
          </Row>
        </Col>

        {/* Summary ############################## */}
        <Col span={24} sm={24} lg={12} style={{ marginTop: 31 }}>
          <Summary
            method={selectedMethod}
            wallet={selectedWallet}
            purchaseData={{
              pay: { amount: payAmount, setAmount: setPayAmount, type: payType, setType: setPayType },
              receive: {
                amount: receiveAmount,
                setAmount: setReceiveAmount,
                type: receiveType,
                setType: setReceiveType,
              },
            }}
            refresh={fetchAccounts}
            fee={fee}
            cst={cst}
            setCst={setCst}
            balance={
              payType == 'eHEX'
                ? Number(EhexBalance.value || 0) / 10 ** 8
                : payType == 'wPLS'
                  ? Number(PlsBalance.value) / 10 ** 18
                  : payType == 'PLSX'
                    ? Number(PlsxBalance.value) / 10 ** 18
                    : payType == 'HEX'
                      ? Number(HexBalance.value) / 10 ** 8
                      : payType == 'WAIT'
                        ? Number(WaitBalance.value) / 10 ** 8
                        : payType == 'INC'
                          ? Number(IncBalance.value) / 10 ** 18
                          : payType == 'PHLPv2'
                            ? Number(PhlpBalance.value) / 10 ** 18
                            : payType == 'TIDE'
                              ? Number(TideBalance.value) / 10 ** 18
                              : payType == 'CST'
                                ? Number(CSTBalance.value) / 10 ** 6
                                : payType == 'GLORY'
                                  ? Number(GloryBalance.value) / 10 ** 6
                                  : 0
            }
            transactionRefresh={transactionRefresh}
            setTransactionRefresh={setTransactionRefresh}
            queueLength={queueLength}
          />
        </Col>

        <Col span={24}>
          <Transaction transactionRefresh={transactionRefresh} />
        </Col>
      </Row>
    </>
  )
}
